import React from 'react';
import styled from 'styled-components';
import SplitPane from './SplitPane';
import Pane from './Pane';

const DefaultPanel=()=><div>Default</div>


const Container = styled.div`
  height: 100%;
  display:flex;
  flex:1;
 background: ${props =>props.background};
    // position:absolute;
    // top:0;
    // bottom:0;
    // right:0;
    // left:0;
    // pointer-events:none;
    // background:transparent;
  .Resizer:hover > div {
    background:red;
  }
 .animatePane {
    transition: all 300ms;
    transition-timing-function: ease-in-out;
  }
  .sticky {
    position:sticky;
    top:0;
    max-height:100vh;
  }
`;
const Sub=styled.div`
  
  display: flex;
  flex:1;
  width:100%;
  .ant-tabs {
    width:100%;
  }
`;

export const SplitView=({
    style,
    children,
    isClose:initialClose,
    isVersionClose:initialVersionClose,
    isSticky
  })=>{
  
  const [sizes,setSizes] = React.useState(["300px",undefined,"300px"]);
  const [isClose,setIsClose] = React.useState(initialClose||false);
  const [isVersionClose,setVersionClose] = React.useState(initialVersionClose||false);
  const [animate,setAnimate] = React.useState(false);  
  
   React.useEffect(() => {    
    setAnimate(true);
    setIsClose(initialClose);
    setTimeout(()=>setAnimate(false),600);
    
  },[initialClose]);
  
  const hideSplit=(value)=>{
    setAnimate(true);
    setIsClose(!isClose);
    setTimeout(()=>setAnimate(false),600);
  };
  
  React.useEffect(() => {    
    setAnimate(true);
    setVersionClose(initialVersionClose);
    setTimeout(()=>setAnimate(false),600);
    
  },[initialVersionClose]);
  


  
  const hideVersionSplit=(value)=>{
    setAnimate(true);
    setVersionClose(!isVersionClose);
    setTimeout(()=>setAnimate(false),600);
  };
  
  
  
  const component1 = children&&Array.isArray(children)&&children.length>0&&children[0]||<DefaultPanel/>;
  const component2 = children&&Array.isArray(children)&&children.length>1&&children[1]||<DefaultPanel/>;  
  const component3 = children&&Array.isArray(children)&&children.length>2&&children[2]||<DefaultPanel/>;  
  const Component1 = component1.type;
  const Component2 = component2.type;
  const Component3 = component3.type;
  
  return (
    <Container className="SplitPaneContainer" style={style}>
      <SplitPane split="vertical" onChange={setSizes}>
        <Pane className={`${isSticky&&"sticky"} ${animate?"animatePane":""}`} isClose={isClose} size={sizes[0]} minSize={"50px"} maxSize={"600px"} >
          <Sub><Component1 hideSplit={hideSplit}  {...component1.props}/></Sub>
        </Pane>
        <Pane size={sizes[1]}>
           <Sub><Component2 hideSplit={hideSplit} {...component2.props}/></Sub>
          </Pane>
          <Pane className={`${isSticky&&"sticky"} ${animate?"animatePane":""}`} isClose={isVersionClose} size={sizes[2]} minSize={"50px"} maxSize={"600px"} left={false}>
             <Sub><Component3 {...component3.props}/></Sub>
          </Pane>
      </SplitPane>
    </Container>
  )
}



export default SplitPane;
export { Pane };